if (!customElements.get('product-bundler')) {
  const chevronSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none"><path d="M1 6.5L6.5 1L12 6.5" stroke="black"/></svg>`;
  
  function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }
  
  customElements.define("product-bundler", class ProductBundler extends HTMLElement {
    constructor() {
      super();
      this.selectedOptions = {};
      this.selectedProducts = {};
    }

    connectedCallback() {
      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});

      document.addEventListener('DOMContentLoaded', () => {
        this.products = JSON.parse(this.dataset.products.replaceAll('%27', '&apos;').replaceAll('%22', '&quot;'));
        this.bundleSize = Number(this.dataset.bundleSize);
        this.bundleWrapper = this.querySelector('[data-bundler-wrap]');
        this.bundleDiscountPercentage = Number(this.dataset.bundleDiscountPercentage);
        this.atcButton = this.querySelector('[data-action="add-to-cart"]');
        this.numberOfOptionsRequired = Object.keys(this.getAllAvailableOptions()).length;
        this.imageWrapper = this.querySelectorAll('[data-product-images]');

        this.productTitle = this.dataset.productTitle;
        this.productHandle = this.dataset.productHandle;
        this.productImage = this.dataset.productImage;

        this.addDelegatedEventListeners();
        this.createBundleForm();
        this.addToCartChannel = new BroadcastChannel('added_to_cart');
        this.updateWairChannel = new BroadcastChannel('updateWair');
        this.updateWairChannel.postMessage('updateWair');
      });
    }
    
    addDelegatedEventListeners() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          accordionId,
          action,
        } = clickedElement.dataset;
            
        let optionName = null, optionValue = null;
        if (clickedElement.closest('input[type="radio"]')) {
          optionName = clickedElement.getAttribute('name');
          optionValue = clickedElement.value;
        }
            
        switch (action) {
          case 'add-to-cart':
            const idsToAdd = [...this.querySelectorAll(`[data-variant]:checked`)].map(({ dataset: { variant } }) => variant);
            
            const bundleId = uuidv4();
            const data = {
              sections: [`${document.querySelector('mini-cart')?.dataset.sectionId}`],
              items: idsToAdd.map((id) => ({ 
                id, 
                quantity: 1, 
                properties: { 
                  _bundle_id: bundleId,
                  _bundle_size: this.bundleSize,
                  _bundle_discount_percentage: this.bundleDiscountPercentage,
                  _bundle_title: this.productTitle
                }
              }))
            };
            fetch('/cart/add.js', {
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            })
              .then((response) => {
                return response.json();
              })
              .then((json) => {
                document.querySelector('mini-cart')?.updateCartHtml(json);
                document.querySelector('mini-cart')?.getRecommendedProducts();
                document.querySelector('mini-cart')?.open();
              })
              .catch(function(err) {
                console.error(err);
              });
            
          break;
          case 'option-select':
            this.selectedOptions[optionName] = optionValue;
            this.selectedProducts = {};
            this.querySelectorAll('[data-selected-color]').forEach(el => el.innerHTML = '');
            this.imageWrapper.forEach((el) => {
              el.innerHTML = `<img class="swiper-slide" src="${this.productImage}" width="1200" height="1467" sizes="100vw" loading="lazy">`;
            });
            this.regenerateColorMarkup();
            this.enabledOrDisableAddToCartButton();
            setTimeout(() => {
              window.dispatchEvent(this.productUpdatedEvent);
            }, 1000);
            break;
          case 'product-select': 
            const colorDisplay = clickedElement.closest('[data-section]')?.previousElementSibling?.querySelector('[data-selected-color]');
            if (colorDisplay) colorDisplay.innerHTML = optionValue;
            
            this.imageWrapper.forEach((el) => {
              el.innerHTML = '';
            });
            this.selectedProducts[optionName] = optionValue;
            Object.keys(this.selectedProducts).forEach((key) => {
              const product = this.products.find((product) => product.color === this.selectedProducts[key]);
              if (product.featured_image) {
                this.imageWrapper.forEach((el) => {
                  el.innerHTML += `<img class="swiper-slide" src="${product.featured_image}" width="1200" height="1467" sizes="100vw" loading="lazy">`;
                });
              }
            });
            this.enabledOrDisableAddToCartButton();
            setTimeout(() => {
              window.dispatchEvent(this.productUpdatedEvent);
            }, 1000);
          break;
          case 'accordion-toggle':
            const content = this.querySelector(`[data-accordion-content="${accordionId}"]`);
            if (!content) return;
            
            if (parseInt(content.style.height) === 0) {
              content.style.height = `${content.scrollHeight + 16}px`;
              clickedElement.querySelector('svg').style.transform = null;
              return;
            }
            
            if (!content.style.height) content.style.height = `${content.scrollHeight + 16}px`;

            setTimeout(() => {
              content.style.height = 0;
              clickedElement.querySelector('svg').style.transform = 'rotate(180deg)';
            }, 10);
          break;
          default: break;
        }        
      });
    }
    
    enabledOrDisableAddToCartButton() {
      if (Object.keys(this.selectedOptions).length + Object.keys(this.selectedProducts).length === this.numberOfOptionsRequired) {
        this.atcButton.removeAttribute('disabled');
        this.atcButton.innerText = 'BUY NOW';
        return;
      }
      
      this.atcButton.setAttribute('disabled', true);
      this.atcButton.innerText = 'SELECT OPTIONS AND COLORS';
    }
    
    createBundleForm() {
      const options = this.getAllAvailableOptions();
      const optionTypes = [...Object.keys(options).map(option => option)];
      const standardOptions = ['size', 'inseam', 'color'];
      const nonStandardOptions = optionTypes.filter(type => !standardOptions.some(standardType => type.toLowerCase().trim().includes(standardType)));
      
      this.bundleWrapper.innerHTML = `
        <div>
          <div class="accordion-header">
            <span class="list-number">1</span>
            <button data-action="accordion-toggle" data-accordion-id="size">
              <strong>PICK YOUR SIZE</strong>
              ${chevronSvg}
            </button>
          </div>
          <div data-accordion-content="size">
            <div class="bundle-form-section">
              ${Object.keys(options).filter(key => key.toLowerCase().trim() === 'size' || key.toLowerCase().trim() === 'inseam')
                .map((key) => `
                  <span class="size-label-wrapper">
                    ${key}
                    ${key.toLowerCase().trim() === 'inseam' ? `
                      <button type="button" data-compare-modal-trigger="" data-drawer-action="open" data-drawer-id="compare">
                        Compare
                      </button>
                    ` : ''}
                  </span>
                  <div data-section="${key}" class="options-section">
                    ${options[key].map((option) => `
                      <span class="radio-wrap">
                        <input data-action="option-select" id="option-${key}-${option}" name="${key}" type="radio" value="${option}" />
                        <span class="selector">
                          <label for="option-${key}-${option}">${option}</label>
                        </span>
                      </span>
                    `).join('')}
                  </div>
                `).join('')
              }
            </div>
          </div>
        </div>
        ${nonStandardOptions.map((nonStandardOption, i) => `
          <div>
            <div class="accordion-header">
              <span class="list-number">${i + 2}</span>
              <button data-action="accordion-toggle" data-accordion-id="${nonStandardOption}">
                <strong>PICK YOUR ${nonStandardOption.toUpperCase()}</strong>
                ${chevronSvg}
              </button>
            </div>
            <div data-accordion-content="${nonStandardOption}">
              <div class="bundle-form-section">
                <span>${nonStandardOption}</span>
                <div data-section="${nonStandardOption}" class="options-section">
                  ${options[nonStandardOption]?.map((option) => `
                    <span class="radio-wrap">
                      <input data-action="option-select" id="option-${nonStandardOption}-${option}" name="${nonStandardOption}" type="radio" value="${option}" />
                      <span class="selector">
                        <label for="option-${nonStandardOption}-${option}">${option}</label>
                      </span>
                    </span>
                  `).join('')}
                </div>
              </div>
            </div>
          </div>
        `)}
        <div>
          <div class="accordion-header">
            <span class="list-number">${nonStandardOptions.length + 2}</span>
            <button data-action="accordion-toggle" data-accordion-id="color">
              <strong>PICK YOUR COLORS</strong>
              ${chevronSvg}
            </button>
          </div>
          <div data-accordion-content="color">
            <div data-colors-wrap class="bundle-form-section">
              ${Object.keys(options).filter(key => key.toLowerCase().trim().includes('color'))
                .map((key) => `
                    <span>${key} <span data-selected-color class="color-label"></span></span>
                    <ul data-section="${key}" class="flex flex-wrap gap-2 py-4">
                      ${options[key].map((option) => `
                        <li class="relative">
                          <label class="sr-only" for="option-${key}-${option}">
                            ${option}
                          </label>
                          <input aria-label="${option}" type="radio" title="${option}" data-action="product-select" id="option-${key}-${option}" name="${key}" value="${option}" class="absolute top-0 left-0 w-full h-full opacity-0 peer cursor-pointer">
                          <div class="border border-transparent outline-none rounded-full flex items-center justify-center h-full w-full peer-checked:border-primaryDark p-0.5">
                            <span class="shadow black w-4 h-4 rounded-full" style="background-color: ${option}; background-image: url('${this.products.find((product) => product.color === option)?.swatch}');"></span>
                          </div>
                        </li>
                      `).join('')}
                    </ul>
                `).join('')
              }
            </div>
          </div>
        </div>
      `
    }
    
    regenerateColorMarkup() {
      const colorsWrap = this.querySelector('[data-colors-wrap]');
      if (!colorsWrap) return;
      
      const options = this.getAllAvailableOptions();
      const currentOptions = Object.values(this.selectedOptions);
      
      colorsWrap.innerHTML = `
        ${Object.keys(options).filter(key => key.toLowerCase().trim().includes('color'))
          .map((key) => `
            <span>${key} <span data-selected-color class="color-label"></span></span>
            <ul data-section="${key}" class="flex flex-wrap gap-2 py-4">
              ${options[key].map((option) => {
                const productInColor = this.products.find((product) => product.color === option);
                const variantWithCurrentOptions = productInColor.variants.find(({ options }) => currentOptions.every(x => options.find(y => y === x)));
                
                if (!variantWithCurrentOptions?.available) return;
                
                return `
                  <li class="relative">
                    <label class="sr-only" for="option-${key}-${option}">
                      ${option}
                    </label>
                    <input data-variant="${variantWithCurrentOptions.id}" aria-label="${option}" type="radio" title="${option}" data-action="product-select" id="option-${key}-${option}" name="${key}" value="${option}" class="absolute top-0 left-0 w-full h-full opacity-0 peer cursor-pointer">
                    <div class="border border-transparent outline-none rounded-full flex items-center justify-center h-full w-full peer-checked:border-primaryDark p-0.5">
                      <span class="shadow black w-4 h-4 rounded-full" style="background-color: ${option}; background-image: url('${this.products.find((product) => product.color === option)?.swatch}');"></span>
                    </div>
                  </li>
                `
              }).join('')}
            </ul>
          `).join('')
        }
      `;
      
      const content = colorsWrap.closest('[data-accordion-content]')
      if (!content) return;
      content.style.height = null;
    }
    
    getAllAvailableOptions() {
      const colors = this.products.map(({ color }) => color);
      const optionTypes = {};
      this.products.forEach(({ options_with_values }) => {
        options_with_values.forEach((option => {
          if (!optionTypes[option.name]) {
            optionTypes[option.name] = option.values;
            return;
          }
          
          optionTypes[option.name] = [...new Set([...optionTypes[option.name], ...option.values])];
        }))
      });
      
      [...Array(this.bundleSize).keys()].forEach(num => {
        optionTypes[`Color ${num + 1}`] = colors;
      });

      return optionTypes;
    }
  });
}